import * as React from "react";
import { ComponentType } from "react";
import { connect } from "react-redux";
import { routerActions } from "react-router-redux";
import ReactTable, { RowInfo } from "react-table";
import { bindActionCreators } from "redux";
import { PersonnelsBreadcrumbs } from "src/helpers/breadcrumbHelper";
import RouterHoc, { IRouterActions, IRouterProps } from "src/hoc/RouterHoc";
import * as NavigationActions from "../../../actions/navigation";
import * as PagingActions from "../../../actions/pages/pagingPage";
import * as PersonnelActions from "../../../actions/personnel";
import { SearchType } from "../../../actions/personnel";
import {
    InlineLoading,
    OverlayLoading
} from "../../../components/common/index";
import { FormFilterInput } from "../../../components/form";
import { RestrictedLayout } from "../../../components/layouts/index";
import { Link } from "../../../components/routing/index";
import {
    FontAwesomeIcon,
    FontAwesomeIcons,
} from "../../../constants/fontAwesomeIcons";
import { PAGE_SIZE_OPTIONS } from "../../../constants/reactTableConstants";
import * as Dtos from "../../../dtos/Tmd.dtos";
import { AllOfAnyOf, CategoryType } from "../../../dtos/Tmd.dtos";
import { RequestState } from "../../../enumerations/RequestState";
import * as AuthenticationHelper from "../../../helpers/authentication";
import { IFormFilter, ITmdState } from "../../../reducers/index";
import PersonnelsSearch from "../PersonnelsSearch/PersonnelsSearch";
import PersonnelsSearchOther from "../PersonnelsSearch/PersonnelsSearchOther";
import { SelectableOption } from "./../PersonnelsSearch/MultiSelect";

import "./PersonnelsPage.scss";

interface IPersonnelsPageParams {}

interface IPersonnelsPageProps extends IRouterProps<IPersonnelsPageParams> {
    // From state
    personnel: Dtos.Personnel[];
    formFilter: IFormFilter;
    formLength: number;

    loadingPersonnel: boolean;
    loadPersonnelSuccess: boolean;
    loadPersonnelFailure: boolean;
    loadPersonnelErrorCode: string;

    user: Dtos.User;
    permissions?: Dtos.PersonnelTmdPermissions[];
    pageSize: number;

    advancedSearchTMDRole: Dtos.PersonnelTmdRole[];
    advancedSearchTMDTrial: Dtos.PersonnelTmdTrial[];
    advancedSearchCategory: Dtos.PersonnelCategory[];
    advancedSearchTrialGroup: Dtos.PersonnelTrialGroup[];

    advancedSearchTMDRoleAND: Dtos.PersonnelTmdRole[];
    advancedSearchTMDTrialAND: Dtos.PersonnelTmdTrial[];
    advancedSearchCategoryAND: Dtos.PersonnelCategory[];
    advancedSearchTrialGroupAND: Dtos.PersonnelTrialGroup[];

    advancedSearchTMDRoleNOT: Dtos.PersonnelTmdRole[];
    advancedSearchTMDTrialNOT: Dtos.PersonnelTmdTrial[];
    advancedSearchCategoryNOT: Dtos.PersonnelCategory[];
    advancedSearchTrialGroupNOT: Dtos.PersonnelTrialGroup[];

    loadingAdvancedSearch: boolean;
    displayAdvancedSearch: boolean;
}

interface IPersonnelsPageActions extends IRouterActions {
    clearPersonnel: PersonnelActions.IPersonnelClearActionCreator;
    loadPersonnel: PersonnelActions.IPersonnelLoadActionCreator;

    navigate: typeof routerActions.push;
    navigateReplace: typeof routerActions.replace;

    filter: PersonnelActions.IPersonnelFilterActionCreator;

    setPageSize: PagingActions.IPagingPageSizeChangedStateActionCreator;

    advancedSearch: PersonnelActions.IPersonnelAdvancedSearchActionCreator;

    tmdRole: PersonnelActions.IPersonnelTMDRoleActionCreator;
    tmdTrial: PersonnelActions.IPersonnelTMDTrialActionCreator;
    category: PersonnelActions.IPersonnelCategoryActionCreator;
    trialGroup: PersonnelActions.IPersonnelTrialGroupActionCreator;

    setBreadcrumbs: NavigationActions.ISetBreadcrumbsActionCreator;
    setDrawerItems: NavigationActions.ISetDrawerItemsActionCreator;

}

type PersonnelsPageProps = IPersonnelsPageProps & IPersonnelsPageActions;

interface PersonnelsPageState {
    showAdvancedSearch: boolean;
    showAndCategoriesSearch: boolean;
    showNotCategoriesSearch: boolean;
    showOtherSearch: boolean;

    tmdRolesAllOfAnyOf: AllOfAnyOf;
    tmdTrialsAllOfAnyOf: AllOfAnyOf;
    categoriesAllOfAnyOf: AllOfAnyOf;
    trialGroupsAllOfAnyOf: AllOfAnyOf;

    ANDtmdRolesAllOfAnyOf: AllOfAnyOf;
    ANDtmdTrialsAllOfAnyOf: AllOfAnyOf;
    ANDcategoriesAllOfAnyOf: AllOfAnyOf;
    ANDtrialGroupsAllOfAnyOf: AllOfAnyOf;

    NOTtmdRolesAllOfAnyOf: AllOfAnyOf;
    NOTtmdTrialsAllOfAnyOf: AllOfAnyOf;
    NOTcategoriesAllOfAnyOf: AllOfAnyOf;
    NOTtrialGroupsAllOfAnyOf: AllOfAnyOf;

    surnameOther: string;
    firstNameOther: string;
    institutionOther: string;
}

class PersonnelsPage extends React.PureComponent<
    PersonnelsPageProps,
    PersonnelsPageState
> {
    constructor(props: PersonnelsPageProps) {
        super(props);

        this.clearPersonnel = this.clearPersonnel.bind(this);
        this.updateSearch = this.updateSearch.bind(this);
        this.updateOther = this.updateOther.bind(this);

        this.state = {
            showAdvancedSearch: false,
            showAndCategoriesSearch: false,
            showNotCategoriesSearch: false,
            showOtherSearch: false,

            tmdRolesAllOfAnyOf: AllOfAnyOf.AllOf,
            tmdTrialsAllOfAnyOf: AllOfAnyOf.AllOf,
            categoriesAllOfAnyOf: AllOfAnyOf.AllOf,
            trialGroupsAllOfAnyOf: AllOfAnyOf.AllOf,

            ANDtmdRolesAllOfAnyOf: AllOfAnyOf.AllOf,
            ANDtmdTrialsAllOfAnyOf: AllOfAnyOf.AllOf,
            ANDcategoriesAllOfAnyOf: AllOfAnyOf.AllOf,
            ANDtrialGroupsAllOfAnyOf: AllOfAnyOf.AllOf,

            NOTtmdRolesAllOfAnyOf: AllOfAnyOf.AllOf,
            NOTtmdTrialsAllOfAnyOf: AllOfAnyOf.AllOf,
            NOTcategoriesAllOfAnyOf: AllOfAnyOf.AllOf,
            NOTtrialGroupsAllOfAnyOf: AllOfAnyOf.AllOf,

            surnameOther: "",
            firstNameOther: "",
            institutionOther: "",
        };
    }

    componentDidMount() {
        const { 
            loadPersonnel, 
            setDrawerItems, 
            setBreadcrumbs
        } = this.props;
        

        setDrawerItems([]);
        setBreadcrumbs(PersonnelsBreadcrumbs());

        loadPersonnel();
    }

    componentDidUpdate(_prevProps: PersonnelsPageProps, _prevState) {
        const {
            setDrawerItems,
            setBreadcrumbs,
            loadPersonnelFailure,
            navigate,
            loadPersonnelErrorCode,
        } = this.props;

        if (loadPersonnelFailure) {
            navigate(`/error/${loadPersonnelErrorCode}`);
        }

        setDrawerItems([]);
        setBreadcrumbs(PersonnelsBreadcrumbs());
    }

    componentWillUnmount() {
        this.clearPersonnel();
    }

    loadSearchOptions() {
        const { tmdRole, tmdTrial, category, trialGroup } = this.props;

        tmdRole();
        tmdTrial();
        category();
        trialGroup();
    }

    toggleAdvancedSearch() {
        if (!this.state.showAdvancedSearch) this.loadSearchOptions();
        this.setState({
            showAdvancedSearch: !this.state.showAdvancedSearch,
        });
    }

    toggleAddAndCategoriesSearch() {
        this.setState({
            showAndCategoriesSearch: !this.state.showAndCategoriesSearch,
        });
    }

    toggleAddNotCategoriesSearch() {
        this.setState({
            showNotCategoriesSearch: !this.state.showNotCategoriesSearch,
        });
    }

    cancelSearch() {
        this.props.loadPersonnel();
        this.setState({
            showAdvancedSearch: false,
        });
    }

    toggleAddOtherSearch() {
        this.setState({
            showOtherSearch: !this.state.showOtherSearch,
        });
    }

    clearPersonnel() {
        this.props.clearPersonnel();
    }

    showPersonnel(): boolean {
        const { loadingPersonnel, loadPersonnelSuccess } = this.props;

        if (!loadingPersonnel && loadPersonnelSuccess) {
            return true;
        }

        return false;
    }

    selectedIds(of: SelectableOption[]): number[] {
        return of.filter((o) => o.selected).map((o) => o.id);
    }

    clickAdvancedSearch(
        showAndCategoriesSearch: boolean,
        showNotCategoriesSearch: boolean,
        showOtherSearch: boolean
    ): void {
        let advancedSeaarch = new Dtos.SearchPersonnelAdvanced();
        advancedSeaarch.allAnyTmdRoles = this.state.tmdRolesAllOfAnyOf;
        advancedSeaarch.tmdRoles = this.selectedIds(
            this.props.advancedSearchTMDRole
        );
        advancedSeaarch.allAnyTmdTrials = this.state.tmdTrialsAllOfAnyOf;
        advancedSeaarch.tmdTrials = this.selectedIds(
            this.props.advancedSearchTMDTrial
        );
        advancedSeaarch.allAnyCategories = this.state.categoriesAllOfAnyOf;
        advancedSeaarch.membershipTypeCategories = this.selectedIds(
            this.props.advancedSearchCategory.filter(
                (f) => f.categoryType == CategoryType.MembershipType
            )
        );
        advancedSeaarch.professionalDisciplineCategories = this.selectedIds(
            this.props.advancedSearchCategory.filter(
                (f) => f.categoryType == CategoryType.ProfessionalDisipline
            )
        );
        advancedSeaarch.allAnyTrialGroups = this.state.trialGroupsAllOfAnyOf;
        advancedSeaarch.trialGroups = this.selectedIds(
            this.props.advancedSearchTrialGroup
        );

        advancedSeaarch.andAllAnyTmdRoles = this.state.ANDtmdRolesAllOfAnyOf;
        advancedSeaarch.andTmdRoles = showAndCategoriesSearch
            ? this.selectedIds(this.props.advancedSearchTMDRoleAND)
            : [];
        advancedSeaarch.andAllAnyTmdTrials = this.state.ANDtmdTrialsAllOfAnyOf;
        advancedSeaarch.andTmdTrials = showAndCategoriesSearch
            ? this.selectedIds(this.props.advancedSearchTMDTrialAND)
            : [];
        advancedSeaarch.andAllAnyCategories =
            this.state.ANDcategoriesAllOfAnyOf;
        advancedSeaarch.andMembershipTypeCategories = showAndCategoriesSearch
            ? this.selectedIds(
                    this.props.advancedSearchCategoryAND.filter(
                        (f) => f.categoryType == CategoryType.MembershipType
                    )
                )
            : [];
        advancedSeaarch.andProfessionalDisciplineCategories =
            showAndCategoriesSearch
                ? this.selectedIds(
                        this.props.advancedSearchCategoryAND.filter(
                            (f) =>
                                f.categoryType ==
                                CategoryType.ProfessionalDisipline
                        )
                    )
                : [];
        advancedSeaarch.andAllAnyTrialGroups =
            this.state.ANDtrialGroupsAllOfAnyOf;
        advancedSeaarch.andTrialGroups = showAndCategoriesSearch
            ? this.selectedIds(this.props.advancedSearchTrialGroupAND)
            : [];

        advancedSeaarch.notAllAnyTmdRoles = this.state.NOTtmdRolesAllOfAnyOf;
        advancedSeaarch.notTmdRoles = showNotCategoriesSearch
            ? this.selectedIds(this.props.advancedSearchTMDRoleNOT)
            : [];
        advancedSeaarch.notAllAnyTmdTrials = this.state.NOTtmdTrialsAllOfAnyOf;
        advancedSeaarch.notTmdTrials = showNotCategoriesSearch
            ? this.selectedIds(this.props.advancedSearchTMDTrialNOT)
            : [];
        advancedSeaarch.notAllAnyCategories =
            this.state.NOTcategoriesAllOfAnyOf;
        advancedSeaarch.notMembershipTypeCategories = showNotCategoriesSearch
            ? this.selectedIds(
                    this.props.advancedSearchCategoryNOT.filter(
                        (f) => f.categoryType == CategoryType.MembershipType
                    )
                )
            : [];
        advancedSeaarch.notProfessionalDisciplineCategories =
            showNotCategoriesSearch
                ? this.selectedIds(
                        this.props.advancedSearchCategoryNOT.filter(
                            (f) =>
                                f.categoryType ==
                                CategoryType.ProfessionalDisipline
                        )
                    )
                : [];
        advancedSeaarch.notAllAnyTrialGroups =
            this.state.NOTtrialGroupsAllOfAnyOf;
        advancedSeaarch.notTrialGroups = showNotCategoriesSearch
            ? this.selectedIds(this.props.advancedSearchTrialGroupNOT)
            : [];

        advancedSeaarch.otherSurname = showOtherSearch
            ? this.state.surnameOther
            : "";
        advancedSeaarch.otherFirstName = showOtherSearch
            ? this.state.firstNameOther
            : "";
        advancedSeaarch.otherInstitution = showOtherSearch
            ? this.state.institutionOther
            : "";

        this.props.advancedSearch(advancedSeaarch);
    }

    updateSearch(
        searchType: SearchType,
        tmdRolesAllOfAnyOf: AllOfAnyOf,
        tmdTrialsAllOfAnyOf: AllOfAnyOf,
        categoriesAllOfAnyOf: AllOfAnyOf,
        trialGroupsAllOfAnyOf: AllOfAnyOf
    ): void {
        switch (searchType) {
            case SearchType.Search: {
                this.setState({
                    tmdRolesAllOfAnyOf: tmdRolesAllOfAnyOf,
                    tmdTrialsAllOfAnyOf: tmdTrialsAllOfAnyOf,
                    categoriesAllOfAnyOf: categoriesAllOfAnyOf,
                    trialGroupsAllOfAnyOf: trialGroupsAllOfAnyOf,
                });
                break;
            }
            case SearchType.SearchAND: {
                this.setState({
                    ANDtmdRolesAllOfAnyOf: tmdRolesAllOfAnyOf,
                    ANDtmdTrialsAllOfAnyOf: tmdTrialsAllOfAnyOf,
                    ANDcategoriesAllOfAnyOf: categoriesAllOfAnyOf,
                    ANDtrialGroupsAllOfAnyOf: trialGroupsAllOfAnyOf,
                });
                break;
            }
            case SearchType.SearchNOT: {
                this.setState({
                    NOTtmdRolesAllOfAnyOf: tmdRolesAllOfAnyOf,
                    NOTtmdTrialsAllOfAnyOf: tmdTrialsAllOfAnyOf,
                    NOTcategoriesAllOfAnyOf: categoriesAllOfAnyOf,
                    NOTtrialGroupsAllOfAnyOf: trialGroupsAllOfAnyOf,
                });
                break;
            }
        }
    }

    updateOther(surname: string, firstName: string, institution: string): void {
        this.setState({
            surnameOther: surname,
            firstNameOther: firstName,
            institutionOther: institution,
        });
    }

    render() {
        const { loadingPersonnel } = this.props;

        return (
            <RestrictedLayout
                permission={Dtos.Permission.PersonnelView}
                loading={loadingPersonnel}
            >
                {this.renderContent()}
            </RestrictedLayout>
        );
    }

    renderContent() {
        const { permissions } = this.props;

        return (
            <div>
                <div className="row">
                    <div className={"col-auto mb-2"}>
                        <h1>Personnel</h1>
                    </div>
                    <div
                        className="col d-flex justify-content-end align-items-stretch"
                        style={{ height: "38px" }}
                    >
                        <button
                            type="button"
                            className="btn btn-secondary mr-2"
                            onClick={() => this.toggleAdvancedSearch()}
                        >
                            Advanced Search
                        </button>
                        <FormFilterInput
                            formFilter={this.props.formFilter}
                            onFilter={(e) => this.props.filter(e)}
                        />
                        <a
                            className="btn btn-info mr-2"
                            target="_blank"
                            href={encodeURI(
                                `/api/personnelrole/export/0/0/0/0?filter=${this.props.formFilter.search}&showInactive=${this.props.formFilter.showInActive}`
                            )}
                        >
                            <FontAwesomeIcon icon={FontAwesomeIcons.Solid.CLOUD_DOWNLOAD} fixedWidth />
                        </a>
                        <Link
                            className={"btn btn-secondary mr-2"}
                            url={"/personnel/byroles"}
                        >
                            Group By Roles
                        </Link>
                        {AuthenticationHelper.hasPermission(
                            permissions,
                            Dtos.Permission.PersonnelCreate
                        ) && (
                            <Link
                                className={"btn btn-primary"}
                                url={"/personnel/create"}
                            >
                                Create
                            </Link>
                        )}
                    </div>
                </div>
                {!this.showPersonnel() ? (
                    <InlineLoading absoluteCenter={true} size={50} />
                ) : null}
                {this.state.showAdvancedSearch ? (
                    <div className="card">
                        <div className="patient-tables ">
                            {this.props.loadingAdvancedSearch && (
                                <OverlayLoading size={40} />
                            )}

                            <PersonnelsSearch
                                update={this.updateSearch}
                                advancedSearchTMDRole={
                                    this.props.advancedSearchTMDRole
                                }
                                advancedSearchTMDTrial={
                                    this.props.advancedSearchTMDTrial
                                }
                                advancedSearchCategory={
                                    this.props.advancedSearchCategory
                                }
                                advancedSearchTrialGroup={
                                    this.props.advancedSearchTrialGroup
                                }
                                searchType={SearchType.Search}
                            />

                            {this.state.showAndCategoriesSearch && (
                                <PersonnelsSearch
                                    update={this.updateSearch}
                                    title={"AND Categories"}
                                    advancedSearchTMDRole={
                                        this.props.advancedSearchTMDRoleAND
                                    }
                                    advancedSearchTMDTrial={
                                        this.props.advancedSearchTMDTrialAND
                                    }
                                    advancedSearchCategory={
                                        this.props.advancedSearchCategoryAND
                                    }
                                    advancedSearchTrialGroup={
                                        this.props.advancedSearchTrialGroupAND
                                    }
                                    searchType={SearchType.SearchAND}
                                />
                            )}

                            {this.state.showNotCategoriesSearch && (
                                <PersonnelsSearch
                                    update={this.updateSearch}
                                    title={"NOT Categories"}
                                    advancedSearchTMDRole={
                                        this.props.advancedSearchTMDRoleNOT
                                    }
                                    advancedSearchTMDTrial={
                                        this.props.advancedSearchTMDTrialNOT
                                    }
                                    advancedSearchCategory={
                                        this.props.advancedSearchCategoryNOT
                                    }
                                    advancedSearchTrialGroup={
                                        this.props.advancedSearchTrialGroupNOT
                                    }
                                    searchType={SearchType.SearchNOT}
                                />
                            )}

                            {this.state.showOtherSearch && (
                                <PersonnelsSearchOther
                                    update={this.updateOther}
                                    title={"Other"}
                                />
                            )}

                            <div className="form-group row pt-0 pb-4 border-top-0">
                                <div className="col-md-6 offset-md-6">
                                    <div className="row bottom-0 border-top-0 pb-0 pt-4">
                                        <div
                                            className="col"
                                            style={{ textAlign: "right" }}
                                        >
                                            <button
                                                type="button"
                                                className="btn btn-outline-dark mr-2"
                                                onClick={() =>
                                                    this.cancelSearch()
                                                }
                                            >
                                                {"Cancel"}
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-secondary mr-2 btn-info"
                                                onClick={() =>
                                                    this.toggleAddAndCategoriesSearch()
                                                }
                                            >
                                                {this.state
                                                    .showAndCategoriesSearch
                                                    ? "Hide AND categories"
                                                    : "Add AND categories"}
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-secondary mr-2 btn-info"
                                                onClick={() =>
                                                    this.toggleAddNotCategoriesSearch()
                                                }
                                            >
                                                {this.state
                                                    .showNotCategoriesSearch
                                                    ? "Hide not categories"
                                                    : "Add not categories"}
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-secondary mr-2 btn-info"
                                                onClick={() =>
                                                    this.toggleAddOtherSearch()
                                                }
                                            >
                                                {this.state.showOtherSearch
                                                    ? "Hide other"
                                                    : "Add other"}
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-secondary"
                                                onClick={() =>
                                                    this.clickAdvancedSearch(
                                                        this.state
                                                            .showAndCategoriesSearch,
                                                        this.state
                                                            .showNotCategoriesSearch,
                                                        this.state
                                                            .showOtherSearch
                                                    )
                                                }
                                            >
                                                Search
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : null}{" "}
                {this.showPersonnel() ? (
                    <div className="card">
                        <div className="patient-tables">
                            {this.props.displayAdvancedSearch
                                ? this.createAdvancedSearchTable()
                                : this.createTable()}
                        </div>
                    </div>
                ) : null}
            </div>
        );
    }

    createTable() {
        const { personnel, pageSize, setPageSize } = this.props;

        if (!personnel || personnel.length == 0) {
            return (
                <div className="card card-shadow p-3">
                    <div className="alert alert-info d-flex mb-0">
                        <div className="mr-2">
                            <FontAwesomeIcon
                                icon={FontAwesomeIcons.Solid.INFO_SQUARE}
                                fixedWidth
                            />
                        </div>
                        <span>There are currently no personnel to view.</span>
                    </div>
                </div>
            );
        }

        const showPagination = personnel.length > pageSize;

        return (
            <div className="table-wrapper">
                <ReactTable
                    data={personnel}
                    pageSizeOptions={PAGE_SIZE_OPTIONS}
                    defaultPageSize={
                        showPagination ? pageSize : personnel.length
                    }
                    pageSize={showPagination ? pageSize : personnel.length}
                    showPagination={showPagination}
                    className="-striped -highlight -clickable"
                    noDataText="There are currently no personnel to display"
                    resizable={false}
                    onPageSizeChange={(val) => setPageSize(val)}
                    defaultSorted={[
                        {
                            id: "firstName",
                            desc: false,
                        },
                        {
                            id: "lastName",
                            desc: false,
                        },
                    ]}
                    getTdProps={(
                        state,
                        rowInfo: RowInfo,
                        _column,
                        _instance
                    ) => {
                        return {
                            onClick: (e, handleOriginal) => {
                                const url: string =
                                    "/personnel/" +
                                    rowInfo.original.id +
                                    "/details";
                                this.props.navigate(url);

                                if (handleOriginal) {
                                    handleOriginal();
                                }
                            },
                        };
                    }}
                    columns={[
                        {
                            id: "id",
                            Header: " ",
                            accessor: "id",
                            maxWidth: 50,
                            Cell: (_props) => (
                                <FontAwesomeIcon
                                    size="lg"
                                    icon={FontAwesomeIcons.Duotone.USER}
                                    fixedWidth
                                />
                            ),
                        },
                        {
                            id: "salutationId",
                            Header: "Salutation",
                            accessor: "salutation.value",
                            maxWidth: 100,
                        },
                        {
                            id: "firstName",
                            Header: "First Name",
                            accessor: "firstName",
                            maxWidth: 250,
                        },
                        {
                            id: "lastName",
                            Header: "Last Name",
                            accessor: "lastName",
                            maxWidth: 250,
                        },
                        {
                            id: "email",
                            Header: "Email",
                            accessor: "email",
                        },
                        {
                            id: "organisation",
                            Header: "Organisation",
                            accessor: "personnelAddresses",
                            Cell: (props) => (
                                <span>
                                    {props.original?.personnelAddresses
                                        ?.filter((x) => x.addressTypeId == 2)
                                        ?.map((x) => x.companyName)
                                        .join(" | ")}
                                </span>
                            ),
                        },
                    ]}
                />
            </div>
        );
    }

    tmdInstitution(row: Dtos.Personnel): string {
        if (row.personnelRoles == null || row.personnelRoles.length == 0) {
            return "";
        }
        return row.personnelRoles
            .filter((role) => role.institution)
            .map((role) => {
                return role.institution.name;
            })
            .join(", ");
    }

    createAdvancedSearchTable() {
        const { personnel, pageSize, setPageSize } = this.props;

        if (!personnel || personnel.length == 0) {
            return (
                <div className="card card-shadow p-3">
                    <div className="alert alert-info d-flex mb-0">
                        <div className="mr-2">
                            <FontAwesomeIcon
                                icon={FontAwesomeIcons.Solid.INFO_SQUARE}
                                fixedWidth
                            />
                        </div>
                        <span>There are currently no personnel to view.</span>
                    </div>
                </div>
            );
        }

        const showPagination = personnel.length > pageSize;

        return (
            <div className="table-wrapper">
                <ReactTable
                    data={personnel}
                    pageSizeOptions={PAGE_SIZE_OPTIONS}
                    defaultPageSize={
                        showPagination ? pageSize : personnel.length
                    }
                    pageSize={showPagination ? pageSize : personnel.length}
                    showPagination={showPagination}
                    className="-striped -highlight -clickable"
                    noDataText="There are currently no personnel to display"
                    resizable={false}
                    onPageSizeChange={(val) => setPageSize(val)}
                    defaultSorted={[
                        {
                            id: "firstName",
                            desc: false,
                        },
                        {
                            id: "lastName",
                            desc: false,
                        },
                    ]}
                    getTdProps={(
                        state,
                        rowInfo: RowInfo,
                        _column,
                        _instance
                    ) => {
                        return {
                            onClick: (e, handleOriginal) => {
                                const url: string =
                                    "/personnel/" +
                                    rowInfo.original.id +
                                    "/details";
                                this.props.navigate(url);

                                if (handleOriginal) {
                                    handleOriginal();
                                }
                            },
                        };
                    }}
                    columns={[
                        {
                            id: "id",
                            Header: " ",
                            accessor: "id",
                            maxWidth: 50,
                            Cell: (_props) => (
                                <FontAwesomeIcon
                                    size="lg"
                                    icon={FontAwesomeIcons.Duotone.USER}
                                    fixedWidth
                                />
                            ),
                        },
                        {
                            id: "salutationId",
                            Header: "Salutation",
                            accessor: "salutation.value",
                            maxWidth: 100,
                        },
                        {
                            id: "firstName",
                            Header: "First Name",
                            accessor: "firstName",
                        },
                        {
                            id: "lastName",
                            Header: "Last Name",
                            accessor: "lastName",
                        },
                        {
                            id: "email",
                            Header: "Email",
                            accessor: "email",
                        },
                        {
                            id: "userName",
                            Header: "User Name",
                            accessor: "userName",
                            maxWidth: 220,
                        },
                        {
                            id: "company",
                            Header: "Company",
                            accessor: "companyName",
                            style: { whiteSpace: "unset" },
                        },
                        {
                            id: "tmdInstitution",
                            Header: "TMD Institution",
                            accessor: (row) => {
                                return this.tmdInstitution(row);
                            },
                            style: { whiteSpace: "unset" },
                        },
                    ]}
                />
            </div>
        );
    }
}

const mapStateToProps = (
    state: ITmdState,
    ownProps: PersonnelsPageProps
): IPersonnelsPageProps => {
    let permissions = state.user.userSummary
        ? state.user.userSummary.permissions
        : [];

    return {
        match: ownProps.match,
        history: ownProps.history,
        location: ownProps.location,

        personnel: state.personnel.formFilteredData!,
        formFilter: state.personnel.formFilter,
        formLength: state.personnel.formLength,

        loadingPersonnel:
            state.personnel.loadState &&
            state.personnel.loadState.status == RequestState.Pending,
        loadPersonnelSuccess:
            state.personnel.loadState &&
            state.personnel.loadState.status == RequestState.Success,
        loadPersonnelFailure:
            state.personnel.loadState &&
            state.personnel.loadState.status == RequestState.Failure,
        loadPersonnelErrorCode: state.personnel.loadState.errorCode,

        user: state.user.data,
        permissions: permissions,
        pageSize: state.pagingPage.pageSize,

        advancedSearchTMDRole: state.personnel.advancedSearchTMDRole,
        advancedSearchTMDTrial: state.personnel.advancedSearchTMDTrial,
        advancedSearchCategory: state.personnel.advancedSearchCategory,
        advancedSearchTrialGroup: state.personnel.advancedSearchTrialGroup,

        advancedSearchTMDRoleAND: state.personnel.advancedSearchTMDRoleAND,
        advancedSearchTMDTrialAND: state.personnel.advancedSearchTMDTrialAND,
        advancedSearchCategoryAND: state.personnel.advancedSearchCategoryAND,
        advancedSearchTrialGroupAND:
            state.personnel.advancedSearchTrialGroupAND,

        advancedSearchTMDRoleNOT: state.personnel.advancedSearchTMDRoleNOT,
        advancedSearchTMDTrialNOT: state.personnel.advancedSearchTMDTrialNOT,
        advancedSearchCategoryNOT: state.personnel.advancedSearchCategoryNOT,
        advancedSearchTrialGroupNOT:
            state.personnel.advancedSearchTrialGroupNOT,

        loadingAdvancedSearch: state.personnel.loadingAdvancedSearch,

        displayAdvancedSearch: state.personnel.displayAdvancedSearch,
    };
};

const mapDispatchToProps = (
    dispatch,
    ownProps: PersonnelsPageProps
): IPersonnelsPageActions => {
    return {
        navigate: ownProps.navigate,
        navigateReplace: ownProps.navigateReplace,

        loadPersonnel: bindActionCreators(
            PersonnelActions.LoadPersonnel,
            dispatch
        ),
        clearPersonnel: bindActionCreators(PersonnelActions.Clear, dispatch),

        filter: bindActionCreators(PersonnelActions.Filter, dispatch),

        setPageSize: bindActionCreators(
            PagingActions.PageSizeChanged,
            dispatch
        ),

        advancedSearch: bindActionCreators(
            PersonnelActions.AdvancedSearch,
            dispatch
        ),

        tmdRole: bindActionCreators(PersonnelActions.TmdRole, dispatch),
        tmdTrial: bindActionCreators(PersonnelActions.TmdTrial, dispatch),
        category: bindActionCreators(PersonnelActions.Category, dispatch),
        trialGroup: bindActionCreators(PersonnelActions.TrialGroup, dispatch),

        setBreadcrumbs: bindActionCreators(
            NavigationActions.SetBreadcrumbs,
            dispatch
        ),
        setDrawerItems: bindActionCreators(
            NavigationActions.SetDrawerItems,
            dispatch
        )
    };
};

export default RouterHoc<IPersonnelsPageParams, PersonnelsPageProps>(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(PersonnelsPage) as unknown as ComponentType<PersonnelsPageProps>
) as ComponentType<any>;
